import React from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'

// project import
import { useSelector } from 'react-redux'
import { LoaderSuspense } from 'src/utils/loader'

const AuthGuard = ({ children }) => {
  const { roles, logged, status } = useSelector((state) => state.auth)

  if (status === 'loading') {
    return <LoaderSuspense />
  } else {
    if (!logged) {
      return <Navigate to="/login" />
    } else if (roles.includes('admin') || roles.includes('waitress')) {
      return children
    } else {
      return <Navigate to="/403" />
    }
  }
}

AuthGuard.propTypes = {
  children: PropTypes.object.isRequired,
}

export default AuthGuard
